import { RESERVED_SLUGS } from '@sirius/contracts/admin'

export type TenantHost =
  { kind: 'apex' } | { kind: 'tenant'; slug: string } | { kind: 'foreign' }

/**
 * Which part of admin-web a hostname is: the apex (`sirius-admin.com`), a
 * tenant (`<slug>.sirius-admin.com`) or something else (reserved names such
 * as `api.`, deeper subdomains, other domains).
 */
export function resolveTenantHost(
  hostname: string,
  baseDomain: string,
): TenantHost {
  const host = hostname.toLowerCase()
  if (host === baseDomain) {
    return { kind: 'apex' }
  }
  const suffix = `.${baseDomain}`
  if (!host.endsWith(suffix)) {
    return { kind: 'foreign' }
  }
  const slug = host.slice(0, -suffix.length)
  if (
    slug === '' ||
    slug.includes('.') ||
    (RESERVED_SLUGS as readonly string[]).includes(slug)
  ) {
    return { kind: 'foreign' }
  }
  return { kind: 'tenant', slug }
}

type CurrentLocation = { protocol: string; port: string }

function origin(hostname: string, { protocol, port }: CurrentLocation) {
  return `${protocol}//${hostname}${port === '' ? '' : `:${port}`}`
}

export function tenantOrigin(
  slug: string,
  baseDomain: string,
  current: CurrentLocation,
) {
  return origin(`${slug}.${baseDomain}`, current)
}

export function apexOrigin(baseDomain: string, current: CurrentLocation) {
  return origin(baseDomain, current)
}
